import _ from 'lodash';
import {useEffect, useState} from 'react';

import Config from '../../utils/Configuration';
import {processAemHeaderFooterHtml} from '../Header/Header.MainView';

export default function FooterMainView({getFooter, footerDocument}) {
    const baseUrl = Config.apiConfig.webURL;
    const styleSheets = [
        `${baseUrl}/etc.clientlibs/mxs/clientlibs/rebrand-global-footer.css`,
        `${baseUrl}/etc.clientlibs/mxs/clientlibs/rebrand-global-bootstrap-dependencies.css`
    ];
    const [loadingStyleSheets, setLoadingStyleSheets] = useState([...styleSheets]);
    const [html, setHtml] = useState('');

    useEffect(() => {
        _.isEmpty(footerDocument) && getFooter();
    }, []);

    useEffect(() => {
        if (typeof footerDocument === 'string') {
            const processedHtml = processAemHeaderFooterHtml(footerDocument, loadingStyleSheets, (link) =>
                setLoadingStyleSheets((value) => value.filter((item) => link !== item))
            );
            setHtml(processedHtml);
        }
    }, [footerDocument]);

    return (
        <>
            <div
                className={`footer ${loadingStyleSheets.length > 0 ? 'd-none' : ''}`}
                dangerouslySetInnerHTML={{__html: html}}
            ></div>
        </>
    );
}
